export const containsSpecialCharacter = (ch: string) => {
  const format = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
  return format.test(ch);
}